import { render, staticRenderFns } from "./XmDeleteConfig.vue?vue&type=template&id=5f7222c7&scoped=true"
import script from "./XmDeleteConfig.vue?vue&type=script&lang=js"
export * from "./XmDeleteConfig.vue?vue&type=script&lang=js"
import style0 from "./XmDeleteConfig.vue?vue&type=style&index=0&id=5f7222c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7222c7",
  null
  
)

export default component.exports